<template>
  <span>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>آیدی:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.id }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>نام کسب و کار:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>تعداد کاربران:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.users.length }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>مدیر کسب و کار:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.created_by }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>شماره تلفن مدیر کسب وکار:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.superuser.phone }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>تاریخ عضویت:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.created_at }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </span>
</template>

<script>
export default {
  props: {
    userInfo: {},
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
};
</script>
